import { Link } from "react-router-dom";
import { useEffect } from "react";

export default function Header(props) {
  const fetchSettings = props.data.settings;
  useEffect(() => {
    let headerHeight = document.querySelector("header").offsetHeight + "px";
    document.querySelector("#app").style.paddingTop = headerHeight;
  }, []);

  return (
    <header className="header">
      <div className="header-inner">
        <div className="logo">
          <Link to="./">
            <img src={`${process.env.PUBLIC_URL}/assets/logo.svg`} alt="Logo" />
            <span>Help Centre</span>
          </Link>
        </div>
        <div className="links">
          {
            <a
              href={fetchSettings.storeFinderUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg width="24" height="24" fill="none" viewBox="4 4 16 16">
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M18.25 11C18.25 15 12 19.25 12 19.25C12 19.25 5.75 15 5.75 11C5.75 7.5 8.68629 4.75 12 4.75C15.3137 4.75 18.25 7.5 18.25 11Z"
                ></path>
                <circle
                  cx="12"
                  cy="11"
                  r="2.25"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                ></circle>
              </svg>

              {`Store Finder`}
            </a>
          }
          {
            <a
              href={fetchSettings.url}
              target="_blank"
              rel="noopener noreferrer"
              className="button"
            >
              <svg width="24" height="24" fill="none" viewBox="4 4 16 16">
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.1"
                  d="M13.25 8.75L9.75 12L13.25 15.25"
                ></path>
              </svg>

              {`Return to ${fetchSettings.return}`}
            </a>
          }
        </div>
      </div>
    </header>
  );
}
